export { initializeMux } from './video';
